import { useTranslation } from 'react-i18next';

function ErrorPage() {
    const [t, i18n] = useTranslation("global");
    return (
        <div>{t('error.title')}</div>
    )
}

export default ErrorPage